import { useState } from "react";
import { DOCS } from "../utils/docs";

export default function Footer() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const [sheetTab, setSheetTab] = useState('company');

  return (
    <>
      <div style={{ marginTop: 24, background: '#111111', padding: '20px 16px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 20, marginBottom: 12 }}>
          {[['company', '회사소개'], ['terms', '이용약관'], ['privacy', '개인정보 처리방침']].map(([key, label], i, arr) => (
            <span key={key} style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <span onClick={() => { setSheetTab(key); setSheetOpen(true); }} style={{ fontSize: 15, color: '#888888', cursor: 'pointer' }}>{label}</span>
              {i < arr.length - 1 && <span style={{ color: '#555555' }}>|</span>}
            </span>
          ))}
        </div>

        {/* 사업자 정보 */}
        <div style={{ borderTop: '1px solid #222', paddingTop: 12, marginBottom: 12 }}>
          <div style={{ fontSize: 13, color: '#555555', lineHeight: 2, textAlign: 'left' }}>
            <div><span style={{ color: '#555555' }}>상호명</span>&nbsp;&nbsp;해무리&nbsp;&nbsp;<span style={{ color: '#555555' }}>대표자</span>&nbsp;&nbsp;김주현</div>
            <div><span style={{ color: '#555555' }}>사업자등록번호</span>&nbsp;&nbsp;592-47-00917</div>
<div><span style={{ color: '#555555' }}>사업장 주소</span>&nbsp;&nbsp;경기도 여주시 교동로 60</div>
            <div><span style={{ color: '#555555' }}>통신판매업 신고번호</span>&nbsp;&nbsp;제 2026-경기여주-00132 호</div>
            <div><span style={{ color: '#555555' }}>고객센터</span>&nbsp;&nbsp;rntwngus24@gmail.com</div>
            <div><span style={{ color: '#555555' }}>전화번호</span>&nbsp;&nbsp;010-6317-9310</div>
            <div style={{ color: '#555555', marginTop: 4 }}>전화 상담은 제공하지 않습니다. 문의하기 게시판을 이용해주세요.</div>
          </div>
        </div>

        <div style={{ textAlign: 'center', fontSize: 15, color: '#555555' }}>© 2026 말투좀요. All rights reserved.</div>
      </div>

      {sheetOpen && (
        <div
          onClick={() => setSheetOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 1000 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ width: '100%', maxWidth: 430, background: '#ffffff', borderRadius: '12px 12px 0 0', height: '70vh', display: 'flex', flexDirection: 'column' }}
          >
            <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 6px', flexShrink: 0 }}>
              <div style={{ width: 32, height: 3, background: '#e0e0e0', borderRadius: 12 }} />
            </div>
            <div style={{ padding: '0 20px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
              <span style={{ fontSize: 16, fontWeight: 600, color: '#111111' }}>서비스 안내</span>
              <button
                onClick={() => setSheetOpen(false)}
                style={{ background: 'none', border: 'none', outline: 'none', fontSize: 40, color: '#bbbbbb', cursor: 'pointer', lineHeight: 1, padding: 0 }}
              >
                ×
              </button>
            </div>
            <div style={{ padding: '0 20px 14px', flexShrink: 0 }}>
              <div style={{ display: 'flex', background: '#f5f5f5', borderRadius: 12, padding: 3, gap: 3 }}>
                {Object.entries(DOCS).map(([key, val]) => (
                  <button key={key} onClick={() => setSheetTab(key)}
                    style={{ flex: 1, padding: '7px 4px', fontSize: 15, background: sheetTab === key ? '#111111' : 'transparent', color: sheetTab === key ? '#ffffff' : '#888888', border: 'none', borderRadius: 8, cursor: 'pointer', fontFamily: "'DM Mono', monospace", fontWeight: sheetTab === key ? 500 : 400, outline: 'none', whiteSpace: 'nowrap' }}>
                    {val.label}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ height: 1, background: '#eeeeee', flexShrink: 0 }} />
            <div style={{ padding: '16px 20px 24px', overflowY: 'auto', flex: 1 }}>
              {DOCS[sheetTab].sections.map((s, i) => (
                <div key={i} style={{ marginBottom: 14 }}>
                  <div style={{ fontSize: 15, fontWeight: 600, color: '#111111', marginBottom: 4, letterSpacing: 0.5 }}>{s.title}</div>
                  <div style={{ fontSize: 15, color: '#888888', lineHeight: 1.8 }}>{s.content}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}